import './index.js';
import angular from 'angular';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';

import controllersModule from './controllers/index.js';
import servicesModule from './services/index.js';
import directivesModule from './directives/index.js';

configAuth.$inject = ['$authProvider', 'domain', '$httpProvider'];
function configAuth($authProvider, domain, $httpProvider) {
  $authProvider.loginUrl    = domain.name + 'sessions.json';
  $authProvider.tokenName   = 'token';
  $authProvider.tokenPrefix = 'thoth';
  $authProvider.tokenType = '';
  $httpProvider.interceptors.push('googleTokenPersistance');
}

runGoogle.$inject = ['GoogleApi', 'Notification'];
function runGoogle(GoogleApi, Notification) {
  GoogleApi.initClient();
  Notification.InitNotification(firebase);
}

configRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];
function configRoutes($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('sign_in', {
      url: '/sign_in',
      templateUrl: 'views/sign_in.html',
      controller: 'SignInCtrl'
    })
    .state('error404', {
      url: '/404',
      templateUrl: '404.html',
      controller: 'SignInCtrl'
    })
    .state('app', {
      url: '/app',
      abstract: true,
      templateUrl: 'views/main.html',
      controller: 'MainCtrl'
    })
    .state('app.changeLogSia', {
      url: '/changeLogSia',
      templateUrl: 'views/_changeLogSia.html',
      controller: 'ChangeLogCtrl'
    })
    .state('app.activities', {
      url: '/activities',
      templateUrl: 'views/activities/index.html',
      controller: 'ActivitiesCtrl'
    })
    .state('app.assignments', { url: '/assignments', abstract: true })
    .state('app.assignments.list', {
      url: '/list',
      templateUrl: 'views/assignments/index.html',
      controller: 'AssignmentsCtrl'
    })
    .state('app.assignments.new', {
      url: '/new',
      templateUrl: 'views/assignments/new.html',
      controller: 'AssignmentsNewCtrl'
    })
    .state('app.assignments.update', {
      url: '/update/:assignmentId',
      templateUrl: 'views/assignments/new.html',
      controller: 'AssignmentsNewCtrl'
    })
    .state('app.assignments.show', {
      url: '/show/:assignmentId',
      templateUrl: 'views/assignments/show.html',
      controller: 'AssignmentsShowCtrl'
    })
    .state('app.showGoogleCalendar', {
      url: '/showGoogleCalendar',
      templateUrl: 'views/activities/showGoogleCalendar.html',
      controller: 'showGoogleCalendarCtrl'
    })
    .state('app.workspaces', { url: '/workspaces', abstract: true })
    .state('app.workspaces.list', {
      url: '/list',
      templateUrl: 'views/workspaces/index.html',
      controller: 'WorkspacesCtrl'
    })
    .state('app.workspaces.new', {
      url: '/new',
      templateUrl: 'views/workspaces/new.html',
      controller: 'WorkspacesNewCtrl'
    })
    .state('app.workspaces.update', {
      url: '/update/:workspacesId',
      templateUrl: 'views/workspaces/new.html',
      controller: 'WorkspacesNewCtrl'
    })
    .state('app.workspaces.show', {
      url: '/show/:workspacesId',
      templateUrl: 'views/workspaces/show.html',
      controller: 'WorkspacesShowCtrl'
    })
    .state('app.clients', { url: '/clients', abstract: true })
    .state('app.clients.list', {
      url: '/list',
      templateUrl: 'views/clients/index.html',
      controller: 'ClientCtrl'
    })
    .state('app.clients.new', {
      url: '/new',
      templateUrl: 'views/clients/new.html',
      controller: 'ClientNewCtrl'
    })
    .state('app.clients.update', {
      url: '/update/:clientId',
      templateUrl: 'views/clients/new.html',
      controller: 'ClientNewCtrl'
    })
    .state('app.clients.show', {
      url: '/show/:clientId',
      templateUrl: 'views/clients/show.html',
      controller: 'ClientShowCtrl'
    })
    .state('app.projects', {
      url: '/projects',
      abstract: true,
      controller: 'ProjectCtrl'
    })
    .state('app.projects.list', {
      url: '/list',
      templateUrl: 'views/projects/index.html',
      controller: 'ProjectIndexCtrl'
    })
    .state('app.projects.new', {
      url: '/new',
      templateUrl: 'views/projects/new.html',
      controller: 'ProjectNewCtrl'
    })
    .state('app.projects.show', {
      url: '/:projectId',
      templateUrl: 'views/projects/show.html',
      controller: 'ProjectShowCtrl'
    })
    .state('app.projects.update', {
      url: '/update/:projectId',
      templateUrl: 'views/projects/new.html',
      controller: 'ProjectNewCtrl'
    })
    .state('app.employees', { url: '/employees', abstract: true })
    .state('app.employees.list', {
      url: '/list',
      templateUrl: 'views/employees/index.html',
      controller: 'EmployeeCtrl'
    })
    .state('app.employees.new', {
      url: '/new',
      templateUrl: 'views/employees/new.html',
      controller: 'EmployeeNewCtrl'
    })
    .state('app.employees.show', {
      url: '/:employeeId',
      templateUrl: 'views/employees/show.html',
      controller: 'EmployeeShowCtrl'
    })
    .state('app.employees.update', {
      url: '/update/:employeeId',
      templateUrl: 'views/employees/new.html',
      controller: 'EmployeeNewCtrl'
    })
    .state('app.users', { url: '/users', abstract: true })
    .state('app.users.list', {
      url: '/list',
      templateUrl: 'views/users/index.html',
      controller: 'UserCtrl'
    })
    .state('app.users.new', {
      url: '/new_user',
      templateUrl: 'views/users/new.html',
      controller: 'UserNewCtrl'
    })
    .state('app.users.update', {
      url: '/update/:userId',
      templateUrl: 'views/users/new.html',
      controller: 'UserNewCtrl'
    })
    .state('app.users.show', {
      url: '/:userId',
      templateUrl: 'views/users/show.html',
      controller: 'UserShowCtrl'
    })
    .state('app.users.show_not_admin', {
      url: '/show_not_admin/:userId',
      templateUrl: 'views/users/show_not_admin.html',
      controller: 'UserShowCtrl'
    })
    .state('app.holydays', { url: '/holydays', abstract: true })
    .state('app.holydays.list', {
      url: '/list',
      templateUrl: 'views/holydays/index.html',
      controller: 'HolydaysCtrl'
    })
    .state('app.reporting', { url: '/reporting', abstract: true })
    .state('app.reporting.list', {
      url: '/list',
      templateUrl: 'views/reporting/reporting_activities.html',
      controller: 'ReportingCtrl'
    })
    .state('app.client_group', { url: '/client_group', abstract: true })
    .state('app.client_group.list', {
      url: '/list',
      templateUrl: 'views/clients_group/index.html',
      controller: 'ClientsGroupCtrl'
    })
    .state('app.client_group.new', {
      url: '/new',
      templateUrl: 'views/clients_group/new.html',
      controller: 'ClientsGroupNewCtrl'
    })
    .state('app.client_group.update', {
      url: '/update/:clientGroupId',
      templateUrl: 'views/clients_group/new.html',
      controller: 'ClientsGroupNewCtrl'
    })
    .state('app.client_group.show', {
      url: '/show/:clientGroupId',
      templateUrl: 'views/clients_group/show.html',
      controller: 'ClientsGroupShowCtrl'
    })
    .state('app.holydays.new', {
      url: '/new',
      templateUrl: 'views/holydays/new.html',
      controller: 'HolydaysNewCtrl'
    })
    .state('app.scope_changes', { url: '/scope_changes', abstract: true })
    .state('app.scope_changes.list', {
      url: '/list',
      templateUrl: 'views/scope_changes/index.html',
      controller: 'ScopeChangeInboxCtrl'
    })
    .state('app.projects.scope_changes', {
      url: '/:projectId/scope_changes',
      abstract: true
    })
    .state('app.projects.scope_changes.new', {
      url: '/new',
      templateUrl: 'views/scope_changes/new.html',
      controller: 'ScopeChangeNewCtrl'
    })
    .state('app.projects.scope_changes.show', {
      url: '/:requestId',
      templateUrl: 'views/scope_changes/show.html',
      controller: 'ScopeChangeShowCtrl'
    })
    .state('app.projects.invoices', {
      url: '/:projectId/invoices',
      abstract: true
    })
    .state('app.projects.invoices.new', {
      url: '/new_invoice',
      templateUrl: 'views/invoices/new.html',
      controller: 'InvoiceNewCtrl'
    })
    .state('app.projects.invoices.update', {
      url: '/update/:invoiceId',
      templateUrl: 'views/invoices/new.html',
      controller: 'InvoiceNewCtrl'
    })
    .state('app.projects.invoices.show', {
      url: '/:invoiceId',
      templateUrl: 'views/invoices/show.html',
      controller: 'InvoiceShowCtrl'
    })
    .state('app.productCatalogs', { url: '/productCatalogs', abstract: true })
    .state('app.productCatalogs.list', {
      url: '/list',
      templateUrl: 'views/productCatalogs/index.html',
      controller: 'ProductCatalogCtrl'
    })
    .state('app.productCatalogs.new', {
      url: '/new',
      templateUrl: 'views/productCatalogs/new.html',
      controller: 'ProductCatalogNewCtrl'
    })
    .state('app.productCatalogs.update', {
      url: '/update/:productId',
      templateUrl: 'views/productCatalogs/new.html',
      controller: 'ProductCatalogNewCtrl'
    })
    .state('app.productCatalogs.show', {
      url: '/:productId',
      templateUrl: 'views/productCatalogs/show.html',
      controller: 'ProductCatalogShowCtrl'
    })
    .state('app.prospects', { url: '/prospects', abstract: true })
    .state('app.prospects.list', {
      url: '/list',
      templateUrl: 'views/prospects/index.html',
      controller: 'ProspectCtrl'
    })
    .state('app.prospects.new', {
      url: '/new',
      templateUrl: 'views/prospects/new.html',
      controller: 'ProspectNewCtrl'
    })
    .state('app.prospects.update', {
      url: '/update/:prospectId',
      templateUrl: 'views/prospects/new.html',
      controller: 'ProspectNewCtrl'
    })
    .state('app.prospects.show', {
      url: '/:prospectId',
      templateUrl: 'views/prospects/show.html',
      controller: 'ProspectShowCtrl'
    })
    .state('app.quotations', { url: '/quotations', abstract: true })
    .state('app.quotations.list', {
      url: '/list',
      templateUrl: 'views/quotations/index.html',
      controller: 'QuotationCtrl'
    })
    .state('app.quotations.new', {
      url: '/new',
      templateUrl: 'views/quotations/new.html',
      controller: 'QuotationNewCtrl'
    })
    .state('app.quotations.update', {
      url: '/update/:quotationId',
      templateUrl: 'views/quotations/new.html',
      controller: 'QuotationNewCtrl'
    })
    .state('app.quotations.show', {
      url: '/:quotationId',
      templateUrl: 'views/quotations/show.html',
      controller: 'QuotationShowCtrl'
    })
    .state('app.app_licenses', { url: '/app_licenses', abstract: true })
    .state('app.app_licenses.list', {
      url: '/list',
      templateUrl: 'views/app_licenses/index.html',
      controller: 'AppLicenseCtrl'
    })
    .state('app.app_licenses.new', {
      url: '/new',
      templateUrl: 'views/app_licenses/new.html',
      controller: 'AppLicensesNewCtrl'
    })
    .state('app.app_licenses.show', {
      url: '/show:app_licenseId',
      templateUrl: 'views/app_licenses/show.html',
      controller: 'AppLicensesShowCtrl'
    });

  $urlRouterProvider.otherwise('app/activities');
}

angular
  .module('thothApp', [
    'ngSanitize',
    'ngAnimate',
    'ui.router',
    'satellizer',
    'angular-loading-bar',
    'toaster',
    'cfp.loadingBar',
    'ngMaterial',
    'ngAria',
    'ngFileSaver',
    'ui.calendar',
    controllersModule,
    directivesModule,
    servicesModule,
  ])
  .constant('domain', {
    name: process.env.API_URL
  })
  .config(configAuth)
  .run(runGoogle)
  .config(configRoutes);
